import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosError } from 'axios'
import {
  AggregatorDetailsForm,
  ApiConfigurationForm,
  FtpConfigurationForm,
  OrderConfiguratinForm,
} from 'components/aggregatorManagement/forms'
import { aggregatorFormFields } from 'components/aggregatorManagement/utils'
import BackButton from 'components/backButton'
import { Button } from 'components/common'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { createAggregator } from 'utils/api/aggregatorApi'
import { ERROR_CODES, PAGE_AGGREGATOR_MANAGEMENT } from 'utils/constants'

import {
  CreateAggregatorType,
  createAggregatorSchema,
} from 'utils/schema/aggregatorSchema'

const { FTP_ACTIVE, API_ACTIVE, API_AUTH_TYPE } = aggregatorFormFields

const CreateAggregator = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<CreateAggregatorType>({
    resolver: yupResolver(createAggregatorSchema),
  })

  const ftpIsActive = watch(
    FTP_ACTIVE.parentKey + '.' + FTP_ACTIVE.key,
  ) as boolean

  const apiIsActive = watch(
    API_ACTIVE.parentKey + '.' + API_ACTIVE.key,
  ) as boolean

  const currentAuthMode = watch(
    API_AUTH_TYPE.parentKey + '.' + API_AUTH_TYPE.key,
  ) as string

  const navigate = useNavigate()

  const handleCreateAggregator = async (data: CreateAggregatorType) => {
    const toastAggregator = toast.loading('Adding aggregator...')

    try {
      await createAggregator(data)

      reset()
      toast.success('Aggregator created successfully', { id: toastAggregator })
      navigate(PAGE_AGGREGATOR_MANAGEMENT.path)
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: toastAggregator,
            duration: 3000,
          })
        }

        const msg = error?.response?.data?.errors?.msg

        if (msg === ERROR_CODES.AGGREGATOR_ALREADY_EXISTS) {
          return toast.error('Aggregator with code already exist.', {
            id: toastAggregator,
          })
        }
      }

      toast.error('Failed to create aggregator', { id: toastAggregator })
    }
  }

  return (
    <>
      <Helmet>
        <title>ORMS Create Aggregator</title>
      </Helmet>

      <BackButton />

      <form onSubmit={handleSubmit(handleCreateAggregator)}>
        {/* Aggregator Details */}
        <AggregatorDetailsForm
          register={register}
          errors={errors}
          setValue={setValue}
        />

        {/* Aggregator FTP Details */}
        <FtpConfigurationForm
          register={register}
          errors={errors}
          setValue={setValue}
          ftpIsActive={ftpIsActive}
        />

        {/* Aggregator API Details */}
        <ApiConfigurationForm
          register={register}
          errors={errors}
          setValue={setValue}
          apiIsActive={apiIsActive}
          currentAuthMode={currentAuthMode}
          control={control}
        />

        <OrderConfiguratinForm
          register={register}
          errors={errors}
          setValue={setValue}
        />
        <Button buttonText="Create" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default CreateAggregator
